/**
 * Pure helpers for Cashier NFC-e emit UX state.
 * Keeps fiscal UI honest: open form ≠ emitted; failure always restores controls.
 */
(function (root) {
    'use strict';

    var PHASE = {
        CLOSED: 'closed',
        FORM_OPEN: 'form_open',
        EMITTING: 'emitting',
        FAILED: 'failed',
    };

    function initialEmitUi(overrides) {
        var base = {
            phase: PHASE.CLOSED,
            tpDoc: 'none',
            errorMessage: '',
            nDocDraft: '',
        };
        if (!overrides) {
            return base;
        }
        for (var k in overrides) {
            if (Object.prototype.hasOwnProperty.call(overrides, k)) {
                base[k] = overrides[k];
            }
        }
        return base;
    }

    function canStartEmit(ui) {
        return !ui || ui.phase !== PHASE.EMITTING;
    }

    function openForm(ui) {
        var next = initialEmitUi(ui);
        next.phase = PHASE.FORM_OPEN;
        next.errorMessage = '';
        return next;
    }

    function cancelForm(ui) {
        var next = initialEmitUi(ui);
        next.phase = PHASE.CLOSED;
        next.errorMessage = '';
        return next;
    }

    function beginEmit(ui) {
        var next = initialEmitUi(ui);
        next.phase = PHASE.EMITTING;
        next.errorMessage = '';
        return next;
    }

    function failEmit(ui, message) {
        var next = initialEmitUi(ui);
        next.phase = PHASE.FAILED;
        next.errorMessage = message || '';
        return next;
    }

    /**
     * Canonical success for POST /cashier action=emiteNfce:
     * error !== true and a positive nfce_id (created or idempotent existing).
     * Do not require cStat=100 — endpoint may respond before authorization UI refresh.
     */
    function isCanonicalEmiteNfceSuccess(response) {
        if (!response || response.error === true || response.error === 'true') {
            return false;
        }
        var id = response.nfce_id != null ? response.nfce_id : response.nfceSaida_id;
        var n = Number(id);
        return isFinite(n) && n > 0;
    }

    function buildEmiteNfcePayload(pedidoId, faturaId, tpDoc, nDoc) {
        var tp = tpDoc == null || tpDoc === '' ? 'none' : String(tpDoc);
        var doc = nDoc == null ? '' : String(nDoc);
        if (tp === 'none') {
            doc = '';
        }
        return {
            params: {
                action: 'emiteNfce',
                pedido_id: pedidoId,
                fatura_id: faturaId,
                tpDoc: tp,
                nDoc: doc,
            },
        };
    }

    function resolveEmitFailureMessage(payload, fallback) {
        if (payload && typeof payload === 'object') {
            if (payload.message) {
                return String(payload.message);
            }
            if (payload.response && payload.response.data && payload.response.data.message) {
                return String(payload.response.data.message);
            }
        }
        if (typeof payload === 'string' && payload.trim() !== '') {
            return payload;
        }
        return fallback || 'Não foi possível emitir a NFC-e. Tente novamente.';
    }

    function isTimeoutLikeError(error) {
        if (!error) {
            return false;
        }
        var code = error.code || (error.response && error.response.status);
        var msg = String(error.message || '').toLowerCase();
        // 499 = nginx: cliente abortou (incidente 306380: POST /cashier 499).
        if (code === 'ECONNABORTED' || code === 'ERR_CANCELED' || code === 408 || code === 499 || code === 504) {
            return true;
        }
        return msg.indexOf('timeout') !== -1 || msg.indexOf('canceled') !== -1 || msg.indexOf('aborted') !== -1;
    }

    var api = {
        PHASE: PHASE,
        initialEmitUi: initialEmitUi,
        canStartEmit: canStartEmit,
        openForm: openForm,
        cancelForm: cancelForm,
        beginEmit: beginEmit,
        failEmit: failEmit,
        isCanonicalEmiteNfceSuccess: isCanonicalEmiteNfceSuccess,
        buildEmiteNfcePayload: buildEmiteNfcePayload,
        resolveEmitFailureMessage: resolveEmitFailureMessage,
        isTimeoutLikeError: isTimeoutLikeError,
    };

    root.FoxCashierNfceUi = api;

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = api;
    }
})(typeof window !== 'undefined' ? window : global);
